<template>
  <div class="page-content home-page">
    <div class="home-wrapper">
      <div class="home-card">
        <!-- Encabezado -->
        <header class="home-header">
          <div>
            <p class="home-title">Panel principal</p>
            <p class="home-subtitle">
              Elige un módulo para administrar el almacén, las órdenes y el inventario.
            </p>
          </div>

          <div class="home-header__meta">
            <span class="home-chip home-chip--soft">
              ⚙️ Configuración
            </span>
            <span class="home-chip home-chip--soft">
              🚚 Operación diaria
            </span>
            <span class="home-chip home-chip--soft">
              📊 Consultas
            </span>
          </div>
        </header>

        <!-- Grid de módulos -->
        <section class="home-grid">
          <!-- 1) Gestión de Productos -->
          <RouterLink
            v-if="$canView && $canView('superadministrador', 'administrador')"
            to="/dashboard/productos"
            class="home-tile"
          >
            <div class="home-tile__inner">
              <div class="home-tile__icon home-tile__icon--config">
                <span>PR</span>
              </div>
              <div class="home-tile__content">
                <span class="home-tile__label">
                  Gestión de Productos
                </span>
                <span class="home-tile__description">
                  Crea y administra el catálogo de productos disponibles en el almacén.
                </span>
                <span class="home-tile__tag home-tile__tag--config">
                  Configuración
                </span>
              </div>
              <div class="home-tile__chevron">›</div>
            </div>
          </RouterLink>

          <!-- 2) Unidades y Seriales -->
          <RouterLink
            v-if="$canView && $canView('superadministrador', 'administrador')"
            to="/dashboard/unidades"
            class="home-tile"
          >
            <div class="home-tile__inner">
              <div class="home-tile__icon home-tile__icon--config">
                <span>UN</span>
              </div>
              <div class="home-tile__content">
                <span class="home-tile__label">
                  Unidades y Seriales
                </span>
                <span class="home-tile__description">
                  Registra y controla las unidades físicas, números de serie y tokens.
                </span>
                <span class="home-tile__tag home-tile__tag--config">
                  Configuración
                </span>
              </div>
              <div class="home-tile__chevron">›</div>
            </div>
          </RouterLink>

          <!-- 3) Relación de Unidades -->
          <RouterLink
            v-if="$canView && $canView('superadministrador', 'administrador')"
            to="/dashboard/relacion-unidades"
            class="home-tile"
          >
            <div class="home-tile__inner">
              <div class="home-tile__icon home-tile__icon--config">
                <span>RU</span>
              </div>
              <div class="home-tile__content">
                <span class="home-tile__label">
                  Relación de Unidades
                </span>
                <span class="home-tile__description">
                  Vincula unidades con productos o kits para mantener trazabilidad.
                </span>
                <span class="home-tile__tag home-tile__tag--config">
                  Configuración
                </span>
              </div>
              <div class="home-tile__chevron">›</div>
            </div>
          </RouterLink>
            <!-- 5) Centros de Activación -->
          <RouterLink
            v-if="$canView && $canView('superadministrador', 'administrador')"
            to="/dashboard/centros-activacion"
            class="home-tile"
          >
            <div class="home-tile__inner">
              <div class="home-tile__icon home-tile__icon--config">
                <span>CA</span>
              </div>
              <div class="home-tile__content">
                <span class="home-tile__label">
                  Centros de Activación
                </span>
                <span class="home-tile__description">
                  Administra los centros donde se entregan, activan o resguardan unidades.
                </span>
                <span class="home-tile__tag home-tile__tag--config">
                  Configuración
                </span>
              </div>
              <div class="home-tile__chevron">›</div>
            </div>
          </RouterLink>

          <RouterLink
            v-if="$canView && $canView('superadministrador', 'administrador')"
            to="/dashboard/almacenes"
            class="home-tile"
          >
            <div class="home-tile__inner">
              <div class="home-tile__icon home-tile__icon--config">
                <span>AL</span>
              </div>
              <div class="home-tile__content">
                <span class="home-tile__label">
                  Almacenes
                </span>
                <span class="home-tile__description">
                  Define almacenes físicos y sus ubicaciones internas con hasta tres niveles.
                </span>
                <span class="home-tile__tag home-tile__tag--config">
                  Configuración
                </span>
              </div>
              <div class="home-tile__chevron">›</div>
            </div>
          </RouterLink>

          <!-- 4) Órdenes de Entrada -->
          <RouterLink
            v-if="$canView && $canView('superadministrador', 'administrador')"
            to="/dashboard/orden-entrada"
            class="home-tile"
          >
            <div class="home-tile__inner">
              <div class="home-tile__icon home-tile__icon--flow">
                <span>EN</span>
              </div>
              <div class="home-tile__content">
                <span class="home-tile__label">
                  Órdenes de Entrada
                </span>
                <span class="home-tile__description">
                  Registra ingresos de mercancía al almacén y actualiza existencias.
                </span>
                <span class="home-tile__tag home-tile__tag--flow">
                  Operación
                </span>
              </div>
              <div class="home-tile__chevron">›</div>
            </div>
          </RouterLink>

        
          <!-- 6) Órdenes de Entrega -->
          <RouterLink
            v-if="$canView && $canView('superadministrador', 'administrador')"
            to="/dashboard/ordenes-entrega"
            class="home-tile"
          >
            <div class="home-tile__inner">
              <div class="home-tile__icon home-tile__icon--flow">
                <span>OE</span>
              </div>
              <div class="home-tile__content">
                <span class="home-tile__label">
                  Órdenes de Entrega
                </span>
                <span class="home-tile__description">
                  Gestiona salidas de equipos a centros, clientes o responsables.
                </span>
                <span class="home-tile__tag home-tile__tag--flow">
                  Operación
                </span>
              </div>
              <div class="home-tile__chevron">›</div>
            </div>
          </RouterLink>

          <!-- 7) Órdenes de Recolección -->
          <RouterLink
            v-if="$canView && $canView('superadministrador', 'administrador')"
            to="/dashboard/ordenes-recoleccion"
            class="home-tile"
          >
            <div class="home-tile__inner">
              <div class="home-tile__icon home-tile__icon--flow">
                <span>OR</span>
              </div>
              <div class="home-tile__content">
                <span class="home-tile__label">
                  Órdenes de Recolección
                </span>
                <span class="home-tile__description">
                  Controla devoluciones, recolecciones y retornos al almacén.
                </span>
                <span class="home-tile__tag home-tile__tag--flow">
                  Operación
                </span>
              </div>
              <div class="home-tile__chevron">›</div>
            </div>
          </RouterLink>

          <!-- 8) Inventario Global -->
          <RouterLink
            v-if="$canView && $canView('superadministrador', 'administrador')"
            to="/dashboard/inventario"
            class="home-tile"
          >
            <div class="home-tile__inner">
              <div class="home-tile__icon home-tile__icon--report">
                <span>IG</span>
              </div>
              <div class="home-tile__content">
                <span class="home-tile__label">
                  Inventario Global
                </span>
                <span class="home-tile__description">
                  Visualiza existencias por producto, estados y unidades asociadas.
                </span>
                <span class="home-tile__tag home-tile__tag--report">
                  Consulta
                </span>
              </div>
              <div class="home-tile__chevron">›</div>
            </div>
          </RouterLink>

          <!-- 9) Historial por Unidad -->
          <RouterLink
            v-if="$canView && $canView('superadministrador', 'administrador')"
            to="/dashboard/historial-unidades"
            class="home-tile"
          >
            <div class="home-tile__inner">
              <div class="home-tile__icon home-tile__icon--report">
                <span>HU</span>
              </div>
              <div class="home-tile__content">
                <span class="home-tile__label">
                  Historial por Unidad
                </span>
                <span class="home-tile__description">
                  Revisa el recorrido completo de una unidad: entradas, entregas y recolecciones.
                </span>
                <span class="home-tile__tag home-tile__tag--report">
                  Consulta
                </span>
              </div>
              <div class="home-tile__chevron">›</div>
            </div>
          </RouterLink>
        </section>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'HomeView',
};
</script>

<style scoped lang="scss">
.home-page {
  width: 100%;
  min-height: calc(100vh - 56px);
  display: flex;
  justify-content: center;
  padding: 1.5rem 1rem;
}

.home-wrapper {
  width: 100%;
  max-width: 1200px;
}

.home-card {
  border-radius: 1.8rem;
  padding: 1.5rem 1.4rem 1.4rem;
  background: radial-gradient(
      circle at 0 0,
      rgba(148, 163, 184, 0.35),
      rgba(15, 23, 42, 0.96)
    );
  backdrop-filter: blur(24px);
  border: 1px solid rgba(148, 163, 184, 0.6);
  box-shadow:
    0 18px 45px rgba(15, 23, 42, 0.9),
    0 0 0 1px rgba(15, 23, 42, 0.85);
}

.home-header {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 0.75rem;
  margin-bottom: 1.1rem;
}

.home-title {
  font-size: 1.2rem;
  font-weight: 600;
  color: #e5e7eb;
}

.home-subtitle {
  font-size: 0.82rem;
  color: #94a3b8;
}

.home-header__meta {
  display: flex;
  flex-wrap: wrap;
  gap: 0.3rem;
  justify-content: flex-end;
}

.home-chip {
  border-radius: 999px;
  padding: 0.16rem 0.7rem;
  font-size: 0.72rem;
  border: 1px solid transparent;
  color: #e5e7eb;
}

.home-chip--soft {
  background: rgba(15, 23, 42, 0.9);
  border-color: rgba(148, 163, 184, 0.7);
}

/* Grid de tarjetas */
.home-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(350px, 1fr));
  gap: 0.75rem;
}

.home-tile {
  text-decoration: none;
}

/* Tarjeta */
.home-tile__inner {
  border-radius: 1.3rem;
  padding: 0.75rem 0.8rem;
  background: radial-gradient(
      circle at 0 0,
      rgba(148, 163, 184, 0.24),
      rgba(15, 23, 42, 0.96)
    );
  border: 1px solid rgba(148, 163, 184, 0.6);
  box-shadow: 0 10px 28px rgba(15, 23, 42, 0.9);
  display: grid;
  grid-template-columns: auto 1fr auto;
  gap: 0.65rem;
  align-items: center;
  min-height: 80px;
  transition:
    transform 0.12s ease-out,
    box-shadow 0.16s ease-out,
    border-color 0.16s ease-out,
    background 0.16s ease-out;
}

/* Icono redondo */
.home-tile__icon {
  width: 40px;
  height: 40px;
  border-radius: 999px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 0.75rem;
  font-weight: 600;
  color: #e5e7eb;
  border: 1px solid rgba(148, 163, 184, 0.7);
  background: radial-gradient(
      circle at 0 0,
      rgba(148, 163, 184, 0.28),
      rgba(15, 23, 42, 1)
    );
}

.home-tile__icon--config {
  border-color: rgba(59, 130, 246, 0.9);
  box-shadow: 0 0 10px rgba(59, 130, 246, 0.55);
}

.home-tile__icon--flow {
  border-color: rgba(16, 185, 129, 0.9);
  box-shadow: 0 0 10px rgba(16, 185, 129, 0.55);
}

.home-tile__icon--report {
  border-color: rgba(234, 179, 8, 0.9);
  box-shadow: 0 0 10px rgba(234, 179, 8, 0.55);
}

/* Contenido */
.home-tile__content {
  display: flex;
  flex-direction: column;
  gap: 0.15rem;
  min-width: 0;
}

.home-tile__label {
  font-size: 0.9rem;
  font-weight: 500;
  color: #e5e7eb;
}

.home-tile__description {
  font-size: 0.78rem;
  color: #9ca3af;
}

.home-tile__tag {
  margin-top: 0.1rem;
  align-self: flex-start;
  border-radius: 999px;
  padding: 0.1rem 0.55rem;
  font-size: 0.7rem;
  border: 1px solid transparent;
}

.home-tile__tag--config {
  border-color: rgba(59, 130, 246, 0.85);
  background: rgba(15, 23, 42, 0.96);
  color: #bfdbfe;
}

.home-tile__tag--flow {
  border-color: rgba(16, 185, 129, 0.9);
  background: rgba(15, 23, 42, 0.96);
  color: #a7f3d0;
}

.home-tile__tag--report {
  border-color: rgba(234, 179, 8, 0.9);
  background: rgba(15, 23, 42, 0.96);
  color: #fef3c7;
}

/* Chevron */
.home-tile__chevron {
  font-size: 1.1rem;
  color: #9ca3af;
}

/* Hover solo en dispositivos con hover real */
@media (hover: hover) {
  .home-tile__inner:hover {
    transform: translateY(-2px);
    box-shadow: 0 16px 36px rgba(15, 23, 42, 0.95);
    border-color: rgba(129, 140, 248, 0.95);
    background: radial-gradient(
        circle at 0 0,
        rgba(129, 140, 248, 0.26),
        rgba(15, 23, 42, 0.98)
      );
  }
}

/* Responsive */
@media (max-width: 768px) {
  .home-card {
    padding: 1.2rem 1rem 1.1rem;
  }

  .home-header {
    flex-direction: column;
    align-items: flex-start;
  }

  .home-title {
    font-size: 1.05rem;
  }

  .home-subtitle {
    font-size: 0.78rem;
  }

  .home-grid {
    grid-template-columns: 1fr;
  }
}
</style>
